@if (operation) {
<tec-collapse [title]="`WORKFLOWS.FORM.OPERATIONS.${operation?.type}` | translate" [badge]="index.toString()">
    <app-developer-curl-button
        ngProjectAs="tec-button-icon"
        [path]="operationCurlPath()"
        titleKey="WORKFLOWS.CURL_MODAL.TITLE_OPERATION"
    />
    <tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_SECTION_TITLE' | translate">
        <div
            [class]="`grid grid-i${(!!operation?.config?.allowed_docs?.dni ? 1 : 0) + (!!operation?.config?.allowed_docs?.passport ? 1 : 0) + (!!operation?.config?.allowed_docs?.nie ? 1 : 0) + (!!operation?.config?.eudi_wallet_enabled ? 1 : 0)}`"
        >
            @if (!!operation?.config?.allowed_docs?.dni) {
                <tec-card-select
                    img="images/dni.png"
                    [title]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_OPTIONS.DNI' | translate"
                    [selected]="true"
                    [disabled]="true"
                />
            }

            @if (!!operation?.config?.allowed_docs?.passport) {
                <tec-card-select
                    img="images/passport.png"
                    [title]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_OPTIONS.PASSPORT' | translate"
                    [selected]="true"
                    [disabled]="true"
                />
            }

            @if (!!operation?.config?.allowed_docs?.nie) {
                <tec-card-select
                    img="images/nie.png"
                    [title]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_OPTIONS.NIE' | translate"
                    [selected]="true"
                    [disabled]="true"
                />
            }

            @if (!!operation?.config?.eudi_wallet_enabled) {
                <tec-card-select
                    img="images/eudi-wallet.png"
                    [title]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_OPTIONS.EUDI' | translate"
                    [selected]="true"
                    [disabled]="true"
                />
            }
        </div>

        @if (!!operation?.config?.allowed_docs?.dni) {
        <div class="item-group">
            <span>{{ 'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_OPTIONS.DNI' | translate | uppercase }}</span>
            <tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.ALLOWED_COUNTRIES' | translate">
                @for (country of operation?.config?.allowed_docs?.dni; track $index; let last = $last) {
                <span>{{ `MASTER.COUNTRIES.${country?.toUpperCase()}` | translate }}{{!last ? ', ' : ''}}</span>
                }

                @if (operation?.config?.allowed_docs?.dni?.length === 0) {
                <span>{{ 'WORKFLOWS.FORM.OPERATIONS.ALLOWED_COUNTRIES_OPTIONS.ALL' | translate }}</span>
                }
            </tec-info-group>
            <tec-info-group
                [label]="'WORKFLOWS.FORM.OPERATIONS.GREEN_CARD_TITLE' | translate"
                [tooltip]="'WORKFLOWS.FORM.OPERATIONS.GREEN_CARD_DESCRIPTION' | translate"
            >
                <tec-tag
                    [label]="
                        operation?.config?.required_check_nie
                            ? ('WORKFLOWS.DETAIL.ACTIVE' | translate)
                            : ('WORKFLOWS.DETAIL.INACTIVE' | translate)
                    "
                    [status]="operation?.config?.required_check_nie ? 'success' : 'disabled'"
                />
            </tec-info-group>
            <tec-info-group
                [label]="'WORKFLOWS.FORM.OPERATIONS.SCAN_BARCODE_TITLE' | translate"
                [tooltip]="'WORKFLOWS.FORM.OPERATIONS.SCAN_BARCODE_DESCRIPTION' | translate"
            >
                <tec-tag
                    [label]="
                        operation?.config?.scan_barcode
                            ? ('WORKFLOWS.DETAIL.ACTIVE' | translate)
                            : ('WORKFLOWS.DETAIL.INACTIVE' | translate)
                    "
                    [status]="operation?.config?.scan_barcode ? 'success' : 'disabled'"
                />
            </tec-info-group>
        </div>
        }

        @if (!!operation?.config?.allowed_docs?.dni && !!operation?.config?.allowed_docs?.passport) {
        <tec-divider />
        }

        @if (!!operation?.config?.allowed_docs?.passport) {
        <div class="item-group">
            <span>{{ 'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_OPTIONS.PASSPORT' | translate | uppercase }}</span>
            <tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.ALLOWED_COUNTRIES' | translate">
                @for (country of operation?.config?.allowed_docs?.passport; track $index; let last = $last) {
                <span>{{ `MASTER.COUNTRIES.${country?.toUpperCase()}` | translate }}{{!last ? ', ' : ''}}</span>
                }

                @if (operation?.config?.allowed_docs?.passport?.length === 0) {
                <span>{{ 'WORKFLOWS.FORM.OPERATIONS.ALLOWED_COUNTRIES_OPTIONS.ALL' | translate }}</span>
                }
            </tec-info-group>
        </div>
        }

        @if (!!operation?.config?.allowed_docs?.nie && (!!operation?.config?.allowed_docs?.dni || !!operation?.config?.allowed_docs?.passport)) {
        <tec-divider />
        }

        @if (!!operation?.config?.allowed_docs?.nie) {
        <div class="item-group">
            <span>{{ 'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_OPTIONS.NIE' | translate | uppercase }}</span>
        </div>
        }
    </tec-tile>

    <tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.CONFIG' | translate">
        <div class="grid grid-e2">
            <tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.OCR_MODE' | translate">
                <span>{{ ocrModeLabelKey | translate }}</span>
            </tec-info-group>

            <tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.FALLBACK' | translate">
                @if (operation?.config?.fallback?.validation === 'manual') {
                <span>{{ 'WORKFLOWS.FORM.OPERATIONS.FALLBACK_MANUAL' | translate }}</span>
                } @else {
                <span>{{ 'WORKFLOWS.FORM.OPERATIONS.FALLBACK_FINISH' | translate }}</span>
                }
            </tec-info-group>
            <tec-info-group
                [label]="'WORKFLOWS.FORM.OPERATIONS.OBFUSCATION_SECTION_TITLE' | translate"
                [tooltip]="'WORKFLOWS.FORM.OPERATIONS.OBFUSCATION_SECTION_DESCRIPTION' | translate"
            >
                <tec-tag
                    [label]="
                        operation?.config?.obfuscation?.fields
                            ? ('WORKFLOWS.DETAIL.ACTIVE' | translate)
                            : ('WORKFLOWS.DETAIL.INACTIVE' | translate)
                    "
                    [status]="operation?.config?.obfuscation?.fields ? 'success' : 'disabled'"
                />
            </tec-info-group>
        </div>
    </tec-tile>

    <tec-tile [title]="'WORKFLOWS.FORM.GENERAL.ANTIFRAUDE_GENERAL' | translate">
        <tec-info-group
            [label]="'WORKFLOWS.FORM.OPERATIONS.CONTRAST_OF_INFORMATION' | translate"
            [tooltip]="'WORKFLOWS.FORM.OPERATIONS.CONTRAST_OF_INFORMATION_DESCRIPTION' | translate"
        >
            @if (operation?.config?.fraud_scoring?.aeat) {
            <tec-tag [label]="'WORKFLOWS.FORM.OPERATIONS.AEAT' | translate" />
            }

            @if (operation?.config?.fraud_scoring?.aml) {
            <tec-tag [label]="'WORKFLOWS.FORM.OPERATIONS.AML' | translate" />
            }

            @if (operation?.config?.fraud_scoring?.pep) {
            <tec-tag [label]="'WORKFLOWS.FORM.OPERATIONS.PEP' | translate" />
            }
        </tec-info-group>

        <tec-divider />

        <div class="item-group">
            <span>{{ 'WORKFLOWS.FORM.OPERATIONS.DEMAND_LEVEL' | translate | uppercase }}</span>

            <div class="grid grid-i3">
                <tec-info-group [label]="'WORKFLOWS.DETAIL.LEVEL' | translate">
                    <span>{{ demandLevelLabel | translate }}</span>
                </tec-info-group>
                <tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.PHOTOCOPY' | translate">
                    <tec-tag
                        [label]="
                            operation?.config?.fraud_scoring?.photocopy_check?.blocking_step
                                ? ('BUTTON.BLOCK' | translate)
                                : ('WORKFLOWS.DETAIL.INACTIVE' | translate)
                        "
                        [status]="
                            operation?.config?.fraud_scoring?.photocopy_check?.blocking_step ? 'warning' : 'disabled'
                        "
                    />
                </tec-info-group>
                <tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.PHOTO' | translate">
                    <tec-tag
                        [label]="
                            operation?.config?.fraud_scoring?.screen_photo?.blocking_step
                                ? ('BUTTON.BLOCK' | translate)
                                : ('WORKFLOWS.DETAIL.INACTIVE' | translate)
                        "
                        [status]="
                            operation?.config?.fraud_scoring?.screen_photo?.blocking_step ? 'warning' : 'disabled'
                        "
                    />
                </tec-info-group>
                <tec-info-group
                    [label]="'WORKFLOWS.FORM.OPERATIONS.NUM_TRIED' | translate"
                    [tooltip]="'WORKFLOWS.FORM.OPERATIONS.NUM_TRIED_TOOLTIP' | translate"
                >
                    <tec-badge [label]="operation?.config?.setting?.total_tries" type="square" />
                </tec-info-group>
                <tec-info-group
                    [label]="'WORKFLOWS.FORM.OPERATIONS.MAX_TIME_SIDE' | translate"
                    [tooltip]="'WORKFLOWS.FORM.OPERATIONS.MAX_TIME_SIDE_TOOLTIP' | translate"
                >
                    <span>{{ operation?.config?.setting?.side_max_time }}s</span>
                </tec-info-group>
            </div>

            <tec-link [label]="'WORKFLOWS.FORM.CONF_ADVANCED' | translate" (click)="openFraudScoring()" />
        </div>
    </tec-tile>

    <tec-tile [title]="'WORKFLOWS.FORM.CONF_ADVANCED' | translate">
        <div class="item-group">
            <span>{{ 'WORKFLOWS.FORM.OPERATIONS.REQUIREMENTS' | translate | uppercase }}</span>

            <div class="grid grid-i3">
                <tec-info-group
                    [label]="'WORKFLOWS.FORM.OPERATIONS.LEGAL_AGE' | translate"
                    [tooltip]="'WORKFLOWS.FORM.OPERATIONS.LEGAL_AGE_DESCRIPTION' | translate"
                >
                    <span
                        >@if (operation?.config?.fraud_scoring?.legal_age) {
                        {{ operation?.config?.fraud_scoring?.legal_age }}
                        {{ 'WORKFLOWS.DETAIL.YEARS' | translate | lowercase }}
                        } @else {
                        -
                        }</span>
                </tec-info-group>
                <tec-info-group
                    [label]="'WORKFLOWS.FORM.OPERATIONS.COUNTRY' | translate"
                    [tooltip]="'WORKFLOWS.FORM.OPERATIONS.COUNTRY_DESCRIPTION' | translate"
                >
                    <tec-tag
                        [label]="`WORKFLOWS.DETAIL.${operation?.config?.fraud_scoring?.valid_country ? 'ACTIVE' : 'INACTIVE'}` | translate"
                        [status]="operation?.config?.fraud_scoring?.valid_country ? 'success' : 'disabled'"
                    />
                </tec-info-group>
                <tec-info-group
                    [label]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENT_EXPIRED' | translate"
                    [tooltip]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENT_EXPIRED_DESCRIPTION' | translate"
                >
                    <tec-tag
                        [label]="`WORKFLOWS.DETAIL.${operation?.config?.fraud_scoring?.expirated ? 'ACTIVE' : 'INACTIVE'}` | translate"
                        [status]="operation?.config?.fraud_scoring?.expirated ? 'success' : 'disabled'"
                    />
                </tec-info-group>
                @if (operation?.config?.fraud_scoring?.expirated) {
                    <tec-info-group
                        [label]="'WORKFLOWS.FORM.OPERATIONS.ALLOWED_DAYS_EXPIRED' | translate"
                        [tooltip]="'WORKFLOWS.FORM.OPERATIONS.ALLOWED_DAYS_EXPIRED_DESCRIPTION' | translate"
                    >
                        <span
                            >{{ operation?.config?.ocr_allowed_expiration }}
                            {{ 'WORKFLOWS.DETAIL.DAYS' | translate | lowercase }}</span
                        >
                    </tec-info-group>
                }
                <tec-info-group
                    [label]="'WORKFLOWS.FORM.OPERATIONS.VALIDATE_ADDRESS' | translate"
                    [tooltip]="'WORKFLOWS.FORM.OPERATIONS.VALIDATE_ADDRESS_DESCRIPTION' | translate"
                >
                    <tec-tag
                        [label]="`WORKFLOWS.DETAIL.${operation?.config?.validate_address ? 'ACTIVE' : 'INACTIVE'}` | translate"
                        [status]="operation?.config?.validate_address ? 'success' : 'disabled'"
                    />
                </tec-info-group>
                <tec-info-group
                    [label]="'WORKFLOWS.FORM.OPERATIONS.VALIDATE_TEAM_NUMBER' | translate"
                    [tooltip]="'WORKFLOWS.FORM.OPERATIONS.VALIDATE_TEAM_NUMBER_DESCRIPTION' | translate"
                >
                    <tec-tag
                        [label]="`WORKFLOWS.DETAIL.${operation?.config?.validate_team_number ? 'ACTIVE' : 'INACTIVE'}` | translate"
                        [status]="operation?.config?.validate_team_number ? 'success' : 'disabled'"
                    />
                </tec-info-group>
            </div>
        </div>

        <tec-divider />

        <div class="item-group">
            <span>{{ 'WORKFLOWS.FORM.OPERATIONS.INTERFACE_AND_ASSISTANCE' | translate | uppercase }}</span>

            <div class="grid grid-i3">
                <tec-info-group
                    [label]="'WORKFLOWS.FORM.OPERATIONS.TUTORIAL' | translate"
                    [tooltip]="'WORKFLOWS.FORM.OPERATIONS.TUTORIAL_DESCRIPTION' | translate"
                >
                    <tec-tag
                        [label]="`WORKFLOWS.DETAIL.${operation?.config?.tutorial ? 'ACTIVE' : 'INACTIVE'}` | translate"
                        [status]="operation?.config?.tutorial ? 'success' : 'disabled'"
                    />
                </tec-info-group>
                <tec-info-group
                    [label]="'WORKFLOWS.FORM.OPERATIONS.ANIMATIONS' | translate"
                    [tooltip]="'WORKFLOWS.FORM.OPERATIONS.ANIMATIONS_DESCRIPTION' | translate"
                >
                    <tec-tag
                        [label]="`WORKFLOWS.DETAIL.${operation?.config?.setting?.show_guide ? 'ACTIVE' : 'INACTIVE'}` | translate"
                        [status]="operation?.config?.setting?.show_guide ? 'success' : 'disabled'"
                    />
                </tec-info-group>
            </div>
        </div>
    </tec-tile>
</tec-collapse>

@if (showModalOcrFraudScoring) {
    <app-modal-ocr-fraud-scoring-details
        [antiFraudConfig]="operation?.config?.fraud_scoring"
        (closeEvent)="closeFraudScoring()"
    />
}
}
